

import { computed, ref } from 'vue'
import moment from 'moment';
import {FilterMatchMode, FilterOperator} from "primevue/api";
import router from "@/router";
import {useToast} from "primevue/usetoast";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import { useConfirm } from "primevue/useconfirm";
import {BaoCaoVeSinhNuocSach} from "@/models/baoCaoVeSinhNuocSach";
import CDCRepository from "@/services/CDCRepository";
import {BaoCaoThongKeTiemVacxin} from "@/models/baoCaoThongKeTiemVacxin";
import {BaoCaoTinhHinhSDVacxinVaDCTC} from "@/models/baoCaoTinhHinhSDVacxinVaDCTC";
import {DanhSachBaoCaoThang} from "@/models/danhSachBaoCaoThang";
import axios from "axios";


export default {
  setup() {
    const confirm = useConfirm();
    const toast = useToast();
    const store = useStore();
    const date = ref();
    const dateTinhHinh = ref();
    const service = ref("");
    const router = useRouter();
    const baoCao = ref({} as BaoCaoTinhHinhSDVacxinVaDCTC);
    const listBaoCao = ref([] as DanhSachBaoCaoThang[]);
    console.log("####################@@@@@@@@@@@@@@@@@@@@@ baoCaoCoSoLaoDong aaaa: ");
    const initDb = () => {
      baoCao.value.baoCaos = [
        {loaiVacxin: "BCG"},
        {loaiVacxin: "Dung môi BCG"},
        {loaiVacxin: "DPT-VGB-HIB (SII)"},
        {loaiVacxin: "DPT"},
        {loaiVacxin: "OPV"},
        {loaiVacxin: "IPV"},
        {loaiVacxin: "Sởi"},
        {loaiVacxin: "Dung môi sởi"},
        {loaiVacxin: "Uốn ván"},
        {loaiVacxin: "VGB 1 liều* (0,5ml)"},
        {loaiVacxin: "Sởi-Rubella"},
        {loaiVacxin: "Dung môi Sởi-Rubella"},
        {loaiVacxin: "Viêm não NB* "},
        {loaiVacxin: "Bơm tiêm 5 ml"},
        {loaiVacxin: "Bơm tiêm BCG"},
        {loaiVacxin: "Bơm tiêm 1 ml"},
        {loaiVacxin: "Hộp an toàn"},
        {loaiVacxin: "Bơm tiêm 1 ml"},
        {loaiVacxin: "Bơm tiêm 1 ml"},
        {loaiVacxin: "Bơm tiêm 1 ml"},
        {loaiVacxin: "Bơm tiêm 1 ml"},
        {loaiVacxin: "Bơm tiêm 2 ml"},
        {loaiVacxin: "Hộp an toàn"},
      ];

    }
    initDb();

    const selectCalendarTinhHinh = () => {
      if((dateTinhHinh.value[0] != null)&&(dateTinhHinh.value[1] != null))
      {
        listBaoCao.value = [];
        CDCRepository.getListBaoCaoTinhHinhSDVacxinVaDCTC(dateTinhHinh.value[0]/1000, dateTinhHinh.value[1]/1000)
            .then((response) => {
              listBaoCao.value = response.data;
              if(listBaoCao.value.length < 1){
                toast.add({
                  severity: 'warn',
                  summary: 'Báo cáo',
                  detail:'Không tìm thấy báo cáo trong khoản thời gian đã chọn',
                  life: 2500
                })
              }
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:err.response.data,
                life: 2500
              })})
      }
    };

    const loadingData = ref(false);
    const baoCaoTinhHinh = ref(false);
    const loadDBTinhHinh = (id) => {
      loadingData.value = true;
      CDCRepository.getBaoCaoTinhHinhSDVacxinVaDCTCById(id)
          .then((response) => {
            baoCaoTinhHinh.value = true;
            baoCao.value = response.data;
            loadingData.value = false;
          })
          .catch(err => {
            loadingData.value = false;
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail: err.response.data,
              life: 2000
            });
          });
    }
    const clearCalendar = () => {
      listBaoCao.value = [];
    }
    const formatDateTime = (date) => {
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format(' DD/MM/YYYY');
    };
    const formatDateTimeHours = (date) => {
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format(' HH:mm DD/MM/YYYY');
    };

    const addReport = () => {
      if(baoCao.value.tuNgay == null || baoCao.value.denNgay == null)
      {
        toast.add({
          severity: 'error',
          summary: 'Lỗi',
          detail:'Vui lòng chọn thời gian báo cáo',
          life: 2000
        });
      }
      else {
        CDCRepository.createBaoCaoThongKeTinhHinhVacxin(baoCao.value)
            .then((response) => {
              const temp = ref({} as BaoCaoTinhHinhSDVacxinVaDCTC);
              baoCao.value = temp.value;
              initDb();
              toast.add({
                severity: 'success',
                summary: 'Thêm báo cáo',
                detail: 'Thêm báo cáo thành công vào hệ thống',
                life: 2000
              });
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            });
      }
    }

    const loadingExport = ref(false);
    const downloadFile = ref(false);
    const fileName = ref("");
    const downLoadFileExport = (file) => {
      axios({
        url: '../api/cdc/downloadLoadFileReport/' + file,
        method: 'GET',
        responseType: 'blob',
      })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], {type: response.data.type}));
            const link = document.createElement('a');
            link.href = url;
           link.setAttribute('download', "BaoCaoTinhHinhVacxin.xlsx");

            toast.add({
              severity: 'success',
              summary: 'Xuất dữ liệu',
              detail: 'Xuất dữ liệu thành công',
              life: 2000
            });
            document.body.appendChild(link);
            link.click();
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    };

    const exportFileTinhHinh = () => {
      console.log("##################@@@@@@@@@@@@@@@@@@@@ exportFileTinhHinh baoCao: " + JSON.stringify(baoCao.value));
      console.log("##################@@@@@@@@@@@@@@@@@@@@ exportFileTinhHinh listBaoCao: " + JSON.stringify(listBaoCao.value));
      loadingExport.value = true;
      downloadFile.value = false;
      const baoCaoExport = ref([] as DanhSachBaoCaoThang[]);
      baoCaoExport.value = listBaoCao.value.filter(x => x.id == baoCao.value.id);
      CDCRepository.exportFileBaoCaoTinhHinhSDVacxin(baoCaoExport.value)
          .then((response) => {
            fileName.value = response.data;
            loadingExport.value = false;
            downloadFile.value = true
            downLoadFileExport(response.data);
            // router.push({
            //   name: 'home'
            // });
          })
          .catch(err => {
            loadingExport.value = false;
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    return {
      date,
      service,
      addReport,
      baoCao,
      selectCalendarTinhHinh,
      loadingData,
      baoCaoTinhHinh,
      loadDBTinhHinh,
      clearCalendar,
      formatDateTime,
      formatDateTimeHours,
      listBaoCao,
      dateTinhHinh,
      exportFileTinhHinh,
      loadingExport
    }
  }

}
